import mp from 'mixpanel-browser'

mp.init('a3f8593d293a1eb7d383547227f1cd09')

export const mixpanel = mp